import Model, { attr, belongsTo } from "@ember-data/model";
import { capitalize } from "@ember/string";

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    creator: Creator;
  }
}

export default class Creator extends Model {
  @attr("string") declare firstName: string;
  @attr("string") declare lastName: string;

  @belongsTo("journal-event", { async: true, inverse: null })
  journalEvent;

  /**
   * - Filters out undefined and empty string values to make sure we don't call capitalize(undefined)
   * - Capitalize each string to change "john" to "John"
   * - joins strings with ' ' to build the final string "John Doe"
   */
  setupNames(names: string[]): string {
    return names
      .filter(Boolean)
      .map(e => capitalize(e))
      .join(" ");
  }

  get fullName(): string {
    return this.setupNames([this.firstName, this.lastName]);
  }

  get reversedFullName(): string {
    return this.setupNames([this.lastName, this.firstName]);
  }
}
